import React, { useEffect, useState } from 'react';
import { useApi } from '@/contexts/AuthContext';
import { TrendingUp, TrendingDown, Eye, Lock } from 'lucide-react';

const C = { navy: '#0D1B2A', slate: '#5C6B7A', line: '#E4E9EF' };
const DIR = {
  opening: { label: 'OPENING FOR MGA', color: '#1B7A3D', Icon: TrendingUp },
  contracting: { label: 'CONTRACTING', color: '#B0413E', Icon: TrendingDown },
  watch: { label: 'WATCH', color: '#8A6D1D', Icon: Eye },
  competitive: { label: 'CARRIER COMPETITIVE', color: '#2A6FC4', Icon: TrendingDown },
};

export default function AppetiteSignalsPage() {
  const api = useApi();
  const [signals, setSignals] = useState([]);

  useEffect(() => {
    api.get('/market-intel/appetite').then(r => setSignals(r.data.items || [])).catch(() => {});
  }, [api]);

  return (
    <div className="space-y-4" data-testid="appetite-signals-page">
      <div className="flex items-start gap-2 p-3 rounded-md text-xs" style={{ background: '#F0F4F8', color: C.slate }} data-testid="read-only-banner">
        <Lock size={13} className="shrink-0 mt-0.5" />
        <span>Read-only market signals mapped onto the platform's live classes. These inform the human who changes appetite rules — they never change appetite configuration themselves. Sources: carrier published results, figures only.</span>
      </div>
      <div className="grid md:grid-cols-2 gap-4">
        {signals.map(s => {
          const d = DIR[s.direction] || DIR.watch;
          return (
            <div key={s.signal_id} className="rounded-lg border bg-white p-4 space-y-2" style={{ borderColor: C.line, borderLeft: `3px solid ${d.color}` }} data-testid={`signal-${s.signal_id}`}>
              <div className="flex items-center justify-between">
                <span className="flex items-center gap-1.5 text-[10px] font-bold" style={{ color: d.color }}><d.Icon size={12} />{d.label}</span>
                <span className="text-[10px]" style={{ color: C.slate }}>{s.carrier} · as at {s.as_at}</span>
              </div>
              <div className="flex flex-wrap gap-1">
                {(s.classes || []).map(cl => (
                  <span key={cl} className="px-2 py-0.5 rounded text-[10px] font-semibold" style={{ background: '#EEF3F9', color: C.navy }}>{cl === 'all' ? 'All classes / capacity' : cl.replace(/_/g, ' ')}</span>
                ))}
              </div>
              <p className="text-xs" style={{ color: C.navy }}><span className="font-semibold">Evidence:</span> {s.evidence}</p>
              <p className="text-xs" style={{ color: C.slate }}><span className="font-semibold" style={{ color: C.navy }}>Read for us:</span> {s.read_for_us}</p>
              <p className="text-[10px]" style={{ color: C.slate }}>{s.source}{s.verified ? ' · verified' : ''}</p>
            </div>
          );
        })}
      </div>
    </div>
  );
}
